import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { UsersService } from '@ops/shared-types';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ops-reset-password',
  standalone: true,
  imports: [CommonModule, OpsInputComponent, TranslateModule],
  templateUrl: './ops-reset-password.component.html',
  styleUrl: './ops-reset-password.component.scss',
})
export class OpsResetPasswordComponent implements OnDestroy {
  password: string;
  confirmPassword: string;
  errorsTrack = {};
  subscriptions: Array<Subscription> = [];
  routerToken: string;

  constructor(private userService: UsersService, private router: Router, private translateService: TranslateService) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  @HostListener('document:keydown', ['$event']) onKeyDown(e: any) {
    if (e.key === 'Enter') {
      setTimeout(() => {
        this.updatePassword();
      }, 100);
      return;
    }
  }

  onErrorHandler(error: string, field?: string) {
    if (!error || error === '') {
      delete this.errorsTrack[field];
    } else {
      this.errorsTrack[field] = error;
    }
  }

  get isDisabled(): boolean {
    if (
      this.password &&
      this.confirmPassword &&
      this.password === this.confirmPassword &&
      Object.keys(this.errorsTrack).length === 0
    ) {
      return false;
    }

    return true;
  }

  get passwordMissmatch(): boolean {
    if (
      this.password &&
      this.confirmPassword &&
      Object.keys(this.errorsTrack).length === 0
    ) {
      if (this.password !== this.confirmPassword) {
        return true;
      }
    }
    return false;
  }

  onPasswordChange(newValue: string): void {
    this.password = newValue;
  }

  onPasswordChangeRepeat(newValue: string): void {
    this.confirmPassword = newValue;
  }

  updatePassword() {
    const verificationPathUrl = document.location.pathname.slice(1);
    const sub = this.userService
      .setNewUserPassword(this.password, verificationPathUrl)

      .subscribe({
        next: (resp) => {
          // console.log('RESP', resp);
          this.router.navigate(['/login']);
        },
        error: (e) => {
          if (e?.error) {
            const error = JSON.parse(e.error);
            window.alert(this.translateService.instant('windowAlert.generic.error', { error: error['message'] }));
          } else {
            window.alert(this.translateService.instant('windowAlert.opsResetPassword.somethingWentWrong'));
          }
        },
      });
    this.subscriptions.push(sub);
  }
}
